/**
 * Fond de la page = couleur du pied de page, tant que celui-ci est à l'écran.
 *
 * POURQUOI (Karim 2026-10-13) : arrivé tout en bas, Safari sur iPhone montre
 * ce qu'il y a APRÈS la page — sous sa barre d'outils, et quand on tire plus
 * loin (rebond). Ce qu'il y peint, c'est le fond de <html> : blanc. Le pied
 * de page noir semblait s'arrêter avant le bas de l'écran, sur une bande
 * blanche vide.
 *
 * Le fond passe donc à la couleur du pied de page tant que celui-ci est
 * visible, et revient à la normale dès qu'il ne l'est plus : le haut de la
 * page (rebond vers le haut, barre d'état) garde son fond clair.
 */
export function useFondSousLePied(
  pied: Readonly<Ref<HTMLElement | null | undefined>>,
  couleur = "#000",
): void {
  if (import.meta.server) return;
  let observateur: IntersectionObserver | null = null;
  let applique = false;

  function appliquer(visible: boolean) {
    if (visible === applique) return;
    applique = visible;
    // Classe (règle de main.css) et non style direct : le fond blanc de base
    // y est imposé en `!important`.
    const html = document.documentElement;
    html.classList.toggle("fond-sous-le-pied", visible);
    if (visible) html.style.setProperty("--fond-sous-le-pied", couleur);
    else html.style.removeProperty("--fond-sous-le-pied");
  }

  onMounted(() => {
    if (!pied.value || !("IntersectionObserver" in window)) return;
    observateur = new IntersectionObserver((entrees) => appliquer(!!entrees[0]?.isIntersecting));
    observateur.observe(pied.value);
  });

  onBeforeUnmount(() => {
    observateur?.disconnect();
    appliquer(false);
  });
}
